export default "__VITE_ASSET__5b1a78ed__"